import { AgResourceLanguage } from '../types';
import { checkout as EnUsCheckout } from '../en-us/checkout';

export const checkout: AgResourceLanguage['checkout'] = {
  ...EnUsCheckout,
  paymentExpress: {
    title: 'Snabbkassa',
    caption: 'eller fortsätt nedan för att betala med kreditkort'
  },
  summaryBlock: {
    title: {
      desktopView: 'Ordersammanfattning',
      mobileView: 'Sammanfattning'
    },
    productsOrderSummary: {
      showProduct: 'Visa Ordersammanfattning',
      label: 'Produkter',
      hideProduct: 'Dölj Ordersammanfattning',
      gift: 'Gratis Gåva',
      giftPrice: 'Gratis',
      shipsEvery: 'Skickas varje',
      shipsOneTime: 'Skickas en gång',
      frequencyUnit: 'dagar',
      welcomeKitRemoved: `
        <p>
          Välkommen tillbaka!
          <br>Tyvärr, vårt välkomstpaket är endast för nya kunder. Behöver du en ersättning? Kontakta vårt Customer Happiness-team.
        </p>
      `
    }
  },
  paymentFields: {
    paymentTitle: 'Betalning',
    paymentReviewTitle: 'Betalning',
    paymentReviewButton: 'Redigera',
    paymentPageContinueButton: 'Granska Order',
    creditCardLabel: 'Kreditkort',
    creditCardReviewText: '{{brand}} som slutar på {{last4}}',
    creditCardCustomError: 'Kortets uppgifter är ofullständiga.',
    sepaLabel: 'SEPA Autogiro',
    sepaReviewText: 'SEPA som slutar på {{name}}',
    sepaDisclaimer: `
      Jag godkänner härmed att Athletic Greens (EU) Limited får dra betalningar från mitt konto via autogiro.
      Vid abonnemang gäller denna godkännande för återkommande betalningar.
      Jag instruerar min bank att godkänna autogiron utfärdade av Athletic Greens (EU) Limited.
      Jag godkänner att den lagstadgade förhandsmeddelandetiden för autogirot minskas till en dag.
      Obs: Jag kan begära återbetalning av det debiterade beloppet inom 8 veckor från respektive debiteringsdatum.
      Villkoren som avtalats med min bank gäller.
    `,
    paymentPageWalletsFields: {
      deleteButton: 'Radera',
      label: 'Betalningsinformation'
    },
    walletsTotalLabel: 'Totalt'
  },
  shippingFields: {
    subTitle: 'Leveransinformation',
    caption: 'Din beställning skickas inom 3-5 arbetsdagar.',
    email: 'E-post',
    countryRegion: 'Land/region',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    addressLine1: 'Adress',
    addressLine2: 'Lägenhet, Suite, Etc',
    city: 'Stad',
    state: 'Stat',
    zipCode: 'Postnummer',
    phone: 'Telefon',
    pccc: 'PCCC/Passnummer',
    isCreateAccount: 'Förbli engagerad med tips, inspiration och community.',
    submitButtonText: 'Fortsätt till Betalning',
    freeSubmitButtonText: 'Granska Order',
    reviewTitle: 'Leverans',
    reviewButton: 'Redigera',
    subscribeOnSms: `
      <p>
        <strong>Skicka ett sms när min AG1 skickas och om exklusivt hälso- och vetenskapsinnehåll.</strong>
        Jag godkänner att&nbsp;ta emot automatiskt genererade marknadsförings-sms från DrinkAG1 till det nummer jag&nbsp;angav ovan.
        Samtycke är inte ett villkor för köp. Meddelande- och datakostnader kan tillkomma. Svara med HELP eller STOP för att avsluta. 
        Se våra <a href="https://drinkag1.com/text-message-terms/" target="_blank" rel="noopener">Villkor för sms</a>, 
        <a href="https://drinkag1.com/privacy/" target="_blank" rel="noopener">Integritetspolicy</a> &amp;
        <a href="https://drinkag1.com/terms-and-conditions/" target="_blank" rel="noopener">Användarvillkor</a>.
      </p>
    `
  },
  placeOrderFields: {
    continueButton: 'Lägg beställning',
    otpCaption: `
      <p>Genom att lägga denna beställning godkänner du 
        <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Användarvillkoren</a>
        och&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" rel="noopener">Integritetspolicyn</a>.
      </p>
    `,
    subscriptionCaption: `
      <p>
        Genom att lägga denna beställning godkänner du 
        <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Användarvillkoren</a>
        och&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" rel="noopener">Integritetspolicyn</a>.
        <br><br>
      </p>
      <p>
        Du köper ett löpande abonnemang. Du ger Athletic Greens tillåtelse att debitera alla betalningsmetoder i filen var 30:e dag till det då aktuella priset. Ditt abonnemang förnyas var 30:e dag
        tills du avbryter det. Du kan när som helst avbryta innan din nästa leverans
        genom att besöka ditt konto eller mejla <a href="mailto:support@drinkag1.com">support@drinkag1.com</a>.
      </p>
    `
  },
  thanksFields: {
    accountPasswordLabel: 'Lösenord',
    minLength: 'Minst 8 tecken',
    maxLength: 'Lösenordet är för långt (maximalt 40 tecken)',
    whitespace: 'Lösenordet börjar eller slutar med mellanslag',
    uppercase: '1 versal',
    lowercase: '1 gemen',
    number: '1 siffra',
    accountButtonLabelCreate: 'Skapa Ett Konto',
    accountButtonLabelVisit: 'Besök Mitt Konto',
    accountButtonLabelError: 'Besök Mitt Konto',
    successMessage: `
      <h1>Välkommen till Grundläggande Näring, {{customerFirstName}}!</h1>
      <p>Bekräftelse har skickats till: {{customerEmail}}</p>
    `,
    errorMessage: `
      <h1>Välkommen till AG1</h1>
      <p>Logga in för att hantera ditt konto, spåra beställningar och&nbsp;handla exklusiva produkter.</p>
    `,
    orderDetails: `
      <p><strong>Ordernummer:</strong> #{{orderId}}</p>
      <p><strong>Levererat till:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
    `,
    accountTitleNotCreated: `
      <h2>Skapa Ett Konto</h2>
      <p>Kontrollera orderstatus, spåra leveranser och mer.</p>
    `,
    accountTitleCreated: `
      <h2>Skapa Ett Konto</h2>
      <p>Kontrollera orderstatus, spåra leveranser och mer.</p>
    `
  },
  unifiedOrderReview: {
    backButton: 'Tillbaka till Butiksavdelningen',
    shippingFieldsTitle: 'Leveransinformation',
    shippingMethodSubTitle: 'Leveransmetod',
    frequencySubTitle: 'Leveransfrekvens',
    frequencyText: 'Varje {{frequency}}',
    frequencyUnit: 'dag',
    paymentTitle: 'Betalning',
    paymentSubTitle: 'Betalningsmetod',
    billingAddressSubTitle: 'Faktureringsadress',
    billingAddressDescription: 'Samma som leveransadress',
    placeOrderButton: 'Lägg beställning',
    commonCaption: `
    <p>
      Du köper ett löpande abonnemang. Du ger Athletic Greens tillåtelse att debitera alla betalningsmetoder i filen var {{order_frequency_days}} dag till det då aktuella priset.
      Ditt abonnemang förnyas var {{order_frequency_days}} dag tills du avbryter.
      Du kan när som helst avbryta innan din nästa leverans genom att besöka ditt konto eller mejla <a href="mailto:support@drinkag1.com">support@drinkag1.com</a>.
    </p>
  `,
    giftTitle: 'Skicka som en gåva',
    giftRecipientEmailLabel: 'Mottagarens E-post*',
    giftMessageLabel: 'Gåvobudskap',
    shippingAddressTitle: 'Adressinformation',
    shippingAddressText: 'Lägg till mottagarens namn och adress'
  },
  thanksFieldsMembers: {
    successMessage: `
      <h1>Hurra, din beställning är på väg!</h1>
      <p>Bekräftelse har skickats till: {{customerEmail}}</p>
    `,
    successMessageGift: `
      <h1>Hurra, din gåvobeställning är bekräftad!</h1>
      <p>En orderbekräftelse har skickats till: {{customerEmail}} och {{giftRecipientEmail}}</p>
    `,
    successMessageFreeGift: `
      <h1>Tack för att du delar!</h1>
      <p>Bekräftelsemail har skickats till: {{customerEmail}} och {{giftRecipientEmail}}</p>
    `,
    orderDetails: `
      <p><strong>Ordernummer:</strong> #{{orderId}}</p>
      <p><strong>Levererat till:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
    `,
    giftOrderDetails: `
      <p><strong>Ordernummer:</strong> #{{orderId}}</p>
      <p><strong>Ordertyp:</strong> Dela Gratis Paket</p>
      <p><strong>Totalt:</strong> {{total}}</p>
      <p><strong>Levererat till:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
      <p>{{email}}</p></div>
    `,
    giftOrderDetailsPaid: `
    <p><strong>Ordernummer:</strong> #{{orderId}}</p>
    <p><strong>Levererat till:</strong> {{customerName}}</p>
    <p><strong>E-post:</strong> {{email}}</p>
    <p>{{address}}</p></div>
    `,
    viewOrderButtonLabel: 'Visa Orderdetaljer',
    shareMorePacksButtonLabel: 'Dela Fler Paket',
    giftMessageTitle: 'Gåvobudskap:'
  },
  // Om Sanity inte fungerar
  header: {
    title: 'KASSA',
    editOrder: 'Redigera Beställning'
  },
  footer: {
    links: [
      { url: 'https://drinkag1.com/privacy', target: true, text: 'Integritetspolicy' },
      { url: 'https://drinkag1.com/terms-and-conditions', target: true, text: 'Användarvillkor' }
    ]
  }
};
